import { makeAutoObservable } from 'mobx';
import { RootStore } from './RootStore';



export class ViewStatusStore {
	private root: RootStore | undefined;

	public progressStatus = {
		open: false,
		progress: 0,
		total: 0,
		messageFunc: (progress: number, total: number) => `${progress}/${total}`,
		title: "",
	};

	public loadingStatus = {
		open: false,
		message: "",
	};

	public statusMessage = "";

	public floodFillThreahold = {
		low: [255, 255, 255] as [number, number, number],
		high: [30, 30, 30] as [number, number, number],
	}

	public floodFillContrastOnly = false;
	public setFloodFillContrastOnly(value: boolean) {
		this.floodFillContrastOnly = value;
	}

	public floodFillReverse = false;
	public setFloodFillReverse(value: boolean) {
		this.floodFillReverse = value;
	}

	public setFloodFillThreaholdHigh(value: number) {
		this.floodFillThreahold = {
			// low: [value * 2, value * 2, value * 2],
			low: [255, 255, 255],
			high: [value, value, value],
		}
	}


	constructor(root: RootStore) {
		this.root = root;
		makeAutoObservable(this);
	}


	public setStatusMessage(message: string) {
		this.statusMessage = message;
	}

	public setProgressStatus(args: {
		open: boolean,
		progress?: number,
		total?: number,
		messageFunc?: (progress: number, total: number) => string,
		title?: string
	}) {
		const { open, progress, total, messageFunc, title } = args;
		console.log(`setProgressStatus: ${open} ${progress} ${total} ${messageFunc} ${title}`);
		this.progressStatus = { open, progress, total, messageFunc, title };
	}

	public setLoadingStatus(args: {
		open: boolean,
		message?: string,
	}) {
		const { open, message = "" } = args;
		this.loadingStatus = { open, message };
	}
}

